import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getServices(callId: string | number) {
  const result = await apiGet(`service/call/${callId}`);
  usePortcallStore().setServices(result);
}
